<template>
  <ModalTemplate :modal="modal">
    <div class="px-4 pb-3 md:px-0 md:pb-5 md:pt-2">
      <div class="flex flex-col items-center gap-2 md:gap-4">
        <lucide-icon
          icon="Check"
          class="mb-4 mt-4 text-green-500"
          :size="64"
        ></lucide-icon>

        <p class="mb-4 text-center text-xl font-medium">
          {{ $t('titles.Send success') }}
        </p>

        <button
          class="btn h-9 bg-gray-100 px-4 py-2 hover:bg-gray-200 dark:bg-neutral-800 dark:hover:bg-neutral-700"
          @click="CLOSE_MODAL"
        >
          {{ $t('control.Close') }}
        </button>
      </div>
    </div>
  </ModalTemplate>
</template>

<script>
import { mapActions } from 'vuex';

import ModalTemplate from '@/components/modal/ModalTemplate.vue';

export default {
  name: 'SuccessCrmLinkModal',
  components: {
    ModalTemplate,
  },
  props: {
    modal: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {};
  },
  computed: {},

  methods: {
    ...mapActions(['CLOSE_MODAL']),
  },
};
</script>
